import { selectCurrentOrganization } from './selectors';
import { useAppSelector } from 'src/app/store/hooks';
import { useOrganizationSettingsRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';

export function useCurrentOrganizationHeadquartersLocation() {
  const currentOrganization = useAppSelector(selectCurrentOrganization);

  const { data, isLoading, isSuccess } = useOrganizationSettingsRetrieveQuery(
    {},
    {
      skip: !currentOrganization?.id,
    }
  );

  return {
    headquartersLocation: data?.headquarters_location,
    isLoading,
    isSuccess,
  };
}
